import _ from 'lodash';
import Vue from 'vue';
import {mapActions, mapState, mapGetters} from 'vuex';
import EventHub from '../../lib/eventHub';
import {AxiosResponse} from 'axios';
import {AlertNotificationModuleConstant, BioProfileModuleConstant, BioServicesConstant, EmployeeProfileModuleConstant, EventConstant, UrlModuleConstant} from '../../lib/constants';
import TeamMemberListService from '../../lib/services/teamMemberListService';
import TeamMemberListMuleService from '../../lib/services/teamMemberListMuleService';
import TeamMemberList from './team-member-list.html';
import BioAdmin from 'types/ba/bioAdmin';
import moment from 'moment';
import 'moment-timezone';
import BioResultsSorter from '../../lib/helpers/bioResultsSorter';

interface IComponentData {
	teamMemberListServiceLoading: boolean;
	teamMembers: BioAdmin.ITeamMemberListProfile[];
	profileParam: number;
	useSpringApi: boolean;
}

const teamMemberListService: BioAdmin.ITeamMemberListService = new TeamMemberListService();
const teamMemberListMuleService: BioAdmin.ITeamMemberListService = new TeamMemberListMuleService();
const bioResultsSorter: BioAdmin.IBioResultsSorter = new BioResultsSorter();

export default Vue.component('teamMemberList', {
	template: TeamMemberList,
	data(): IComponentData {
		return {
			teamMemberListServiceLoading: true,
			teamMembers: [],
			profileParam: 0,
			useSpringApi: false,
		};
	},
	computed: {
		...mapState(BioProfileModuleConstant.name, [
			'bioProfile',
		]),
		...mapState(EmployeeProfileModuleConstant.name, [
			'employeeProfile',
		]),
		...mapGetters(UrlModuleConstant.name, {
			getGlobalPageDriverUrl: UrlModuleConstant.getter.getGlobalPageDriverUrl,
			getUrlParameter: UrlModuleConstant.getter.getUrlParameter,
		}),
		outOfSyncProfiles: function (): BioAdmin.ITeamMemberListProfile[] {
			return bioResultsSorter.sortByPublishStatus(this.teamMembers.filter((profile: BioAdmin.ITeamMemberListProfile) => {
				return profile.rolesOutOfSync;
			}));
		},
	},
	methods: {
		...mapActions(AlertNotificationModuleConstant.name, {
			synchronizeAlertNotificationStore: AlertNotificationModuleConstant.action.synchronize,
		}),
		...mapActions(EmployeeProfileModuleConstant.name, {
			synchronizeEmployeeProfileStore: EmployeeProfileModuleConstant.action.synchronize,
		}),
		...mapActions(UrlModuleConstant.name, {
			synchronizeUrlStore: UrlModuleConstant.action.synchronize,
		}),
		getList(employeeId: number) {
			if (this.useSpringApi)
				return teamMemberListService.getList(employeeId).then((response: AxiosResponse<BioAdmin.ITeamMemberListProfile[]>) => {
					this.teamMembers = response.data;
				});
			else
				return teamMemberListMuleService.getList(employeeId).then((response: AxiosResponse<BioAdmin.ITeamMemberListProfile[]>) => {
					this.teamMembers = response.data;
				});
		},
	},
	created(): void {
		EventHub.$on(EventConstant.TeamMemberListServiceLoading, (loading: boolean) => {
			this.teamMemberListServiceLoading = loading;
		});

		Promise.all([this.synchronizeAlertNotificationStore(), this.synchronizeEmployeeProfileStore(), this.synchronizeUrlStore()]).then(() => {
			this.profileParam = this.getUrlParameter('profile');
			const featureFlags = window.lt.features;
			if(featureFlags) {
				const feature = featureFlags[featureFlags.findIndex( (x: any) => x.featureId === 'biosSpringApi')];
				if(feature && feature.enabled)
					this.useSpringApi = true;
			}
			if (this.profileParam > 0) {
				this.getList(this.profileParam);
			} else {
				this.getList(this.employeeProfile.employeeDetails.employeeId);
			}
		});
	},
});
